/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Dropfileshere4Inputs */

const en_coinvestments_dataroom_dropfileshere4 = /** @type {(inputs: Coinvestments_Dataroom_Dropfileshere4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop files here`)
};

/**
* | output |
* | --- |
* | "Drop files here" |
*
* @param {Coinvestments_Dataroom_Dropfileshere4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_dropfileshere4 = /** @type {((inputs?: Coinvestments_Dataroom_Dropfileshere4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Dropfileshere4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_dropfileshere4(inputs)
});
export { coinvestments_dataroom_dropfileshere4 as "coInvestments_dataRoom_dropFilesHere" }